/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const LoginResponseR = t.interface({
  urlRedirect: t.string
});

// optional attributes
const LoginResponseO = t.partial({});

export const LoginResponse = t.intersection(
  [LoginResponseR, LoginResponseO],
  "LoginResponse"
);

export type LoginResponse = t.TypeOf<typeof LoginResponse>;
